import {mergeProperties} from "../components/Utility";

export const getGSTFormData = (data) => {
    const initialData = {
        gstNumber: "",
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getInvoiceSettingFormData = (data) => {
    const initialData = {
        prefix: '',
        year: '',
        startSeq: ''
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getOrderInvoiceSettingFormData = (data) => {
    const initialData = {
        prefix: '',
        year: '',
        startSeq: ''
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getBankSettingFormData = (data) => {
    const initialData = {
        accountNumber: '',
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getAllSettingFormData = (data) => {
    const initialData = {
        enableDisable: {
            bankPrint: false,
            gstPrint: false,
            sacCode: false,
        }
    };
    return mergeProperties(initialData, data);
};

